export default __webpack_public_path__ + "static/media/airlockz-wht-banner-3.747233a8.jpg";